import { useEffect, useState } from 'react'

import dynamic from 'next/dynamic'
import Router from 'next/router'
import { toast } from 'react-toastify'

import Banner from 'containers/Home/components/Banner'
import Blog from 'containers/Home/components/Blog'
import FirstFold from 'containers/Home/components/FirstFold'
import FrequentlyQuestions from 'containers/Home/components/FrequentlyQuestions'
import HowItWorks from 'containers/Home/components/HowItWorks'
import KnowMore from 'containers/Home/components/Knowmore'
const OurClientsCarousel = dynamic(
	() => import('containers/Home/components/OurClientsCarousel'),
	{ ssr: false }
)
import ScheduleAppointmentHome from 'containers/Home/components/ScheduleAppointmentHome'
import Testimonials from 'containers/Home/components/Testimonials'
import WhyDoTherapy from 'containers/Home/components/WhyDoTherapy'

import { useUser } from 'providers/UserProvider'

import { sendHomeViewEvent } from 'components/shared/DataLayer'
import FooterIntercomClickableHome from 'components/shared/FooterStatic/FooterIntercomClickableHome'
import { DownloadAppCard } from 'components/v2/DownloadAppCard'
import { HeaderRendering } from 'components/v2/Header'
import { SummitCountdown } from 'components/v2/SummitCountdown/SummitCountdown'
import { SummitPopUp } from 'components/v2/SummitPopUp'
import Wrapper from 'components/Wrapper'

import { HOME_H1 } from 'utils/seo/h1Generator'

const DynamicModal = dynamic(
	() => import('containers/Home/components/FirstFold/SearchModal'),
	{
		ssr: false
	}
)

const metaTags = {
	title: 'Terapia Online Onde Você Estiver | Vittude',
	description:
		'Faça Terapia Online e dê o primeiro passo no autocuidado. A Vittude conecta você a psicólogos de diversas linhas terapêuticas em um ambiente totalmente seguro.'
}

const Home = ({ posts, censusRedirectedCode }) => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [vittudeMatch, setVittudeMatch] = useState(false)
	const [firstStep, setFirstStep] = useState(1)

	const { isUserLoggedIn, isProfessional } = useUser()

	const isClient = typeof window !== 'undefined'

	const handleModal = (isVittudeMatch, step = 1) => {
		if (isVittudeMatch) {
			setVittudeMatch(true)
		}

		setFirstStep(step)
		setIsModalOpen(!isModalOpen)
	}

	useEffect(() => {
		if (isClient) {
			sendHomeViewEvent({
				variant: 'PRINCIPAL',
				location: window.location.href,
				referrer: document.referrer,
				title: metaTags.title
			})

			if (censusRedirectedCode) {
				handleCensusRedirectedToast(censusRedirectedCode)
			}
		}
	}, [censusRedirectedCode])

	useEffect(() => {
		if (isUserLoggedIn) {
			Router.push(
				isProfessional
					? '/painel?menu=consultas'
					: '/painel?menu=minhas-consultas'
			)
		}
	}, [isUserLoggedIn])

	return (
		<Wrapper
			noIndex={false}
			home={true}
			metaTags={metaTags}
			loadGoogleMapsScript={true}
		>
			<h1 className='sr-only'>{HOME_H1}</h1>
			<SummitCountdown />
			<HeaderRendering openModal={handleModal} />
			<FirstFold handleModal={handleModal} />
			<OurClientsCarousel />
			<Banner />
			<HowItWorks handleModal={handleModal} />
			<ScheduleAppointmentHome handleModal={handleModal} />
			<KnowMore />
			<WhyDoTherapy handleModal={handleModal} />
			<Testimonials />
			{posts?.length > 0 && <Blog posts={posts} />}
			<FrequentlyQuestions />

			<FooterIntercomClickableHome />
			{/* Search Modal */}
			{isClient && (
				<DynamicModal
					isModalOpen={isModalOpen}
					toggleModal={handleModal}
					isVittudeMatch={vittudeMatch}
					firstStep={firstStep}
				/>
			)}
			<DownloadAppCard />
			<SummitPopUp variant='home' />
		</Wrapper>
	)
}

const CENSUS_REDIRECTED_TOAST = {
	censusResponseError:
		'Ocorreu um erro. Por favor, verifique a URL e tente novamente.',
	consentTermError:
		'Ocorreu um erro. Por favor, verifique a URL e tente novamente.',
	consentTermDenied:
		'Para prosseguir com o Censo é necessário aceitar o Termo de Consentimento para Tratamento de Dados Pessoais.'
}

const handleCensusRedirectedToast = (censusRedirectedCode) => {
	if (CENSUS_REDIRECTED_TOAST[censusRedirectedCode]) {
		const toastMessage = CENSUS_REDIRECTED_TOAST[censusRedirectedCode]

		toast.error(toastMessage, {
			autoClose: 5000,
			hideProgressBar: false,
			closeButton: true
		})
	}
}

export default Home
